<template>
  <Upload :before-upload="handleUpload" :action="action" :accept="accept" name="uploadFile">
    <slot name="text">
      <Button icon="ios-cloud-upload-outline">{{ $t('upload.selectFile') }}</Button>
    </slot>
  </Upload>
</template>

<script>
export default {
  name: 'UploadFile',
  props: {
    value: { type: [Object, File], default: null }, // file
    action: { type: String, default: '#' },
    accept: { type: String, default: '-' },
  },

  data() {
    return {
      uploadfFles: this.value,
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newV) {
        this.uploadfFles = newV
      },
    },
    uploadfFles: {
      immediate: true,
      handler(newV) {
        this.$emit('input', newV)
      },
    },
  },

  methods: {
    handleUpload(file) {
      // TODO: limit || type
      this.uploadfFles = file
      this.$emit('handleUpload', this.uploadfFles)
      return false
    },
  },
}
</script>
